<div class="purchase-page">

  <!-- HERO HEADER -->
  <div class="hero-section">

    <div>

      <div class="mini-title">
        {{ t('inventoryControl') }}
      </div>

      <h1>
        {{ t('purchaseManagement') }}
      </h1>

      <p>
        {{ t('manageSupplierPurchases') }}
      </p>

    </div>

    <button class="top-save-btn" (click)="savePurchase()">
      💾 {{ t('savePurchase') }}
    </button>

  </div>

  <!-- SUPPLIER CARD -->
  <div class="section-card">

    <div class="section-title">
      {{ t('supplierInformation') }}
    </div>

    <div class="supplier-grid">

      <!-- NAME -->
      <div class="field">

        <label>
          {{ t('supplierName') }}
        </label>

<select
  [(ngModel)]="purchase.supplierId"
  (change)="onSupplierChange()">

  <option [ngValue]="null">
    {{ t('selectSupplier') }}
  </option>

  <option
    *ngFor="let s of suppliers"
    [ngValue]="s.id">

    {{ s.name }}

  </option>

</select>


</div>

      <!-- CONTACT -->
      <div class="field">

        <label>
          {{ t('contactNumber') }}
        </label>

        <input type="text" [(ngModel)]="purchase.supplierContact" placeholder="Enter contact number" />

      </div>

      <div class="field">

  <label>
    {{ t('paidAmount') }}
  </label>

  <input
    type="number"
    [(ngModel)]="purchase.paidAmount"
    placeholder="Enter paid amount" />

</div>

    </div>

  </div>

  <!-- PRODUCT ITEMS -->
  <div class="item-card" *ngFor="let item of purchase.items; let i = index">

    <div class="item-header">

      <h3>
        {{ t('productItem') }}
      </h3>

      <button class="remove-btn" (click)="removeItem(i)">
        ✕
      </button>

    </div>

    <div class="item-grid">

      <!-- CATEGORY -->
      <div class="field">

        <label>
          {{ t('category') }}
        </label>

        <select [(ngModel)]="item.category">

          <option value="">
            {{ t('selectCategory') }}
          </option>

          <option *ngFor="let c of categories" [value]="c">
            {{ c }}
          </option>

        </select>

      </div>

      <!-- PRODUCT -->
      <div class="field product-field">

        <label>
          {{ t('searchProduct') }}
        </label>

        <input type="text" placeholder="Search product..." [(ngModel)]="item.search" (input)="onItemSearch(item)" />

        <!-- PRODUCT LIST -->
        <div class="product-dropdown" *ngIf="
            item.search ||
            item.category
          ">

          <div class="product-option" *ngFor="
              let p of getFilteredProducts(item)
            " [class.active]="
              item.productId == p.id
            " (click)="selectProduct(item, p)">

            <!-- LEFT -->
            <div class="product-left">

              <div class="serial">
                {{ p.id }}
              </div>
<img
  [src]="getImage(p.imageUrl)"
  (error)="$any($event.target).src='assets/no-image.png'"
/>

              <div class="details">

                <h4>
                  {{ p.name }}
                </h4>

                <div class="cat">
                  {{ p.category?.name }}
                </div>

                <div class="stock">

                  {{ t('stock') }}:
                  {{ p.stock | bnNumber }}

                  {{ p.unit }}

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      <!-- QTY -->
      <div class="field">

        <label>
          {{ t('quantityLabel') }}
        </label>

        <div class="qty-wrapper">

          <input type="number" [(ngModel)]="item.quantity" />

          <div class="unit-box">

            {{
            getSelectedProduct(
            item.productId
            )?.unit || t('unitPiece')
            }}

          </div>

        </div>

      </div>

      <!-- BUY -->
      <div class="field">

        <label>
          {{ t('buyPrice') }}
        </label>

        <input type="number" [(ngModel)]="item.unitPrice" />

      </div>

      <!-- SELL -->
      <div class="field">

        <label>
          {{ t('sellPrice') }}
        </label>

        <input type="number" [(ngModel)]="item.sellPrice" />

      </div>

    </div>

  </div>

  <!-- ACTION -->
  <button class="add-btn" (click)="addItem()">
    {{ t('addNewProductItem') }}
  </button>

<!-- SUMMARY -->
<div class="summary-grid">

  <!-- TOTAL -->
  <div class="summary-card blue">

    <div class="summary-label">
      {{ t('totalPurchase') }}
    </div>

    <div class="summary-value">
      {{ getTotal() | bnNumber:'৳ ' }}
    </div>

  </div>

  <!-- PROFIT -->
  <div class="summary-card green">

    <div class="summary-label">
      {{ t('expectedProfit') }}
    </div>

    <div class="summary-value">
      {{ getProfit() | bnNumber:'৳ ' }}
    </div>

  </div>

  <!-- DUE -->
  <div class="summary-card orange">

    <div class="summary-label">
      {{ t('supplierDue') }}
    </div>

    <div class="summary-value">
      {{ getDue() | bnNumber:'৳ ' }}
    </div>

  </div>

</div>